import React, { useContext, useEffect, useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import axios from 'axios';
import PageTitle from '../../Components/PageTitle';
import { ConfigContext } from '../../Context/ConfigContext';
import { NavLink, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { currentDateAndTime, decodeData,decodeUrl,encodeData, } from '../../Constants/constants';
import { useLocation } from 'react-router-dom';

const EditSalaryHeadOrder = ({ initialItems }) => {
    const { apiURL, apiHeaderJSON,permissions} = useContext(ConfigContext);
    const locationParams = useLocation();
    const queryParams = new URLSearchParams(locationParams.search);
    const encodedData = queryParams.get("abs");
     const decodedDataId = decodeUrl(encodedData);
    const decodedData = encodedData ? decodeData(encodedData,permissions) : [];
    const title = queryParams.get("title");
    const headType = queryParams.get("type");
    const page = queryParams.get("page");
    const limit = queryParams.get("limit");

    const navigate = useNavigate();
    const [items, setItems] = useState(initialItems);
    const [isDrag, setIsDrag] = useState(false);
    const [postLoading, setPostLoading] = useState(false);
    const [pagination, setPagination] = useState({
        next: false,
        prev: false,
        page: 1,
        total_records: "",
        total_pages: "",
        limit: 999,
    });
    const [filter, setFilter] = useState({
        keyword: null,
        checkHeadType: null,
    });

    // Handling the drag end
    const handleDragEnd = (result) => {
        if (!result.destination) return;
        const updatedItems = Array.from(items);
        const [movedItem] = updatedItems.splice(result.source.index, 1);
        updatedItems.splice(result.destination.index, 0, movedItem);
        console.log("updatedItems ===>>");
        console.log(updatedItems);
        setItems(updatedItems);
        setIsDrag(true);
    };

    const getList = () => {
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Payrolls/GetSalaryRegisterList`, {
            params: {
                limit: pagination?.limit || 999,
                page: pagination?.page || 1,
                keyword: filter?.keyword || "",
                checkHeadType: filter?.checkHeadType || "",
                date: currentDateAndTime(),
            }, headers
        }).then((response) => {
            let data = response.data;
            if (response.data.success === true) {
                setItems(data?.result?.data);
            } else {
                console.error("Error fetching list");
            }
        }).catch(function (error) {
            console.log("error", error);
        });
    }

    useEffect(() => {
        getList();
    }, [])

    const handleSubmit = async () => {
        const headers = apiHeaderJSON;
        let getListId = items?.map((val) => {
            return { company_salary_head_id: val?.company_salary_head_id }
        });
        console.log(getListId);
        const formdata ={
            date: currentDateAndTime()
        }
        try {
            setPostLoading(true);
            Swal.fire({
                title: 'Are you sure?',
                text: "You want to change the hierarchy, It will effect the payroll processing, report and payslip!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, Change!',
                cancelButtonText: 'No, cancel!',
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.post(`${apiURL}Payrolls/salaryRegisterHeadOrder`, {...formdata,getListId} ,{headers},

                    ).then((response) => {
                            const { success } = response.data;
                            // console.log("handleSubmit ~ response =======>>>", response);
                            if (success === true) {
                                Swal.fire({
                                    title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                                    text: response.data.message,
                                    icon: success ? 'success' : 'error',
                                    showConfirmButton: true,
                                    allowOutsideClick: false,
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        getList();
                                    }
                                });

                            } else {

                                Swal.fire({
                                    title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                                    text: response.data.message,
                                    icon: success ? 'success' : 'error',
                                    showConfirmButton: true,
                                    allowOutsideClick: false,
                                })

                            }
                            setPostLoading(false);
                        }).catch((error)=>{
                            console.log(error);
                            setPostLoading(false);
                        });
                }
            });
        } catch (error) {
            console.error('Error updating order:', error);
        }
    };

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <br />
                    <PageTitle title={`Salary Head List`} primary={`Home`} />
                    <div style={{ padding: "0.5rem" }} className="card">
                        <div className="card-header align-items-center d-flex">
                            <h4 className="card-title mb-0 flex-grow-1">
                                {"Update Salary Head Order"} <small className=' text-muted'>(Move the Salary Heads by dragging them up and down)</small>
                            </h4>
                            {/* <button className="btn btn-success btn-sm" 
                            onClick={()=> navigate(-1)}                            >
                                <i className="bx bx-list-ul label-icon align-middle fs-4 " />
                            </button> */}
                            <button className="btn btn-success btn-sm" 
                            // to={`/SalaryReport?abs=${encodeData(decodedDataId)}${title && headType ? `&title=${title}&type=${headType}` : title ? `&title=${title}` : headType ? `&type=${headType}` : ""}${(title || headType) && (page || limit )? `&page=${page}&limit=${limit}`: (page || limit )? `&page=${page}&limit=${limit}` : ""}`}
                            onClick={()=> navigate(`/SalaryReport?abs=${encodeData(decodedDataId)}${title && headType ? `&title=${title}&type=${headType}` : title ? `&title=${title}` : headType ? `&type=${headType}` : ""}${(title || headType) && (page || limit )? `&page=${page}&limit=${limit}`: (page || limit )? `&page=${page}&limit=${limit}` : ""}`)}  
                            >
                                <i className="bx bx-list-ul label-icon align-middle fs-4 " />
                            </button>
                        </div>
                        <div className="card-body">
                            <div>
                                {/* Add some CSS to ensure Droppable renders correctly */}
                                <div style={{ "maxHeight": "60vh", "overflowY": "auto", padding: "10px", border: "1px solid #F0F0F0", borderRadius: "5px" }}>
                                    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '200px', }}>
                                        <DragDropContext onDragEnd={handleDragEnd}>
                                            <Droppable droppableId="list">
                                                {(provided) => (
                                                    <ol
                                                        {...provided.droppableProps}
                                                        ref={provided.innerRef}
                                                        style={{
                                                            // backgroundColor: '#eaeaea',
                                                            padding: '20px',
                                                            minHeight: '100px' // Ensure the droppable area is visible
                                                        }}
                                                    >
                                                        {items?.map((item, index) => (
                                                            <Draggable
                                                                key={String(item.company_salary_head_id)} // Ensure it's a string and unique
                                                                draggableId={String(item.company_salary_head_id)}
                                                                index={index}
                                                            >
                                                                {(provided) => (
                                                                    <li
                                                                    className='onHoverGreen'
                                                                        ref={provided.innerRef}
                                                                        {...provided.draggableProps}
                                                                        {...provided.dragHandleProps}
                                                                        style={{
                                                                            ...provided.draggableProps.style,
                                                                            padding: "8px",
                                                                            margin: "4px 0",
                                                                            // backgroundColor: "#ffff",
                                                                            border: "1px solid #eaeaea",
                                                                            borderRadius: "4px"

                                                                        }}
                                                                    >
                                                                        {item.company_salary_head}
                                                                    </li>
                                                                )}
                                                            </Draggable>
                                                        ))}
                                                        {provided.placeholder}
                                                    </ol>
                                                )}
                                            </Droppable>
                                        </DragDropContext>
                                    </div>
                                </div>
                                <div style={{ marginTop: "20px", marginLeft: "Auto" }}>
                                    <button
                                        disabled={!isDrag}
                                        onClick={handleSubmit}
                                        className={`btn btn-primary btn-label waves-effect right waves-light float-right`}
                                    >
                                        <i className={`ri-save-line label-icon align-middle fs-16 ms-2`} />{" "}
                                        {"Update"}
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditSalaryHeadOrder;
